import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons';

export interface StatusColor {
  color?: string;
  backgroundColor: string;
}
/* TODO: refactor this, config should not include css, we should use named colors where the style is defined in the theme or css layer */
export const STATUS_COLORS: StatusColor[] = [
  { color: '#333', backgroundColor: '#F48F93' }, // red
  { color: '#333', backgroundColor: '#FEC400' }, // yellow
  { color: '#333', backgroundColor: '#ABE5C3' }, // green
  { color: '#333', backgroundColor: '#ACE0F6' }, // blue
  { color: '#333', backgroundColor: '#DFE0EB' } // gray
];

function isSameStatusColor(colorA: StatusColor, colorB: StatusColor): boolean {
  return (
    colorA.color === colorB.color &&
    colorA.backgroundColor === colorB.backgroundColor
  );
}

type StyledColorBlockProps = {
  selected?: boolean;
  colorValue: string;
};

const StyledColorBlock = styled.div<StyledColorBlockProps>`
  position: relative;
  width: auto;
  height: auto;
  margin-left: 1px;
  margin-right: 1px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 2px solid
    ${props => (props.selected ? props.colorValue : 'rgba(255, 255, 255, 0)')};
  transition: border 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);

  &:hover {
    cursor: pointer;
    border: 2px solid ${props => props.colorValue};
  }

  .content {
    width: 38px;
    height: 30px;
    font-size: 1.5em;
    font-weight: 500;
    border-radius: 6px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      font-size: 1.35em;
    }
  }
`;

export interface ColorSelectorProps {
  color?: StatusColor;
  onChange?: (color: StatusColor | undefined) => void;
}

const ColorSelector: React.FC<ColorSelectorProps> = (
  props: ColorSelectorProps
) => {
  const { onChange } = props;
  const color: StatusColor | undefined =
    props.color && typeof props.color === 'object' ? props.color : undefined;

  return (
    <Grid container>
      {STATUS_COLORS.map((colorStyle: StatusColor, index: number) => {
        const { backgroundColor } = colorStyle;
        const selected: boolean =
          !!color && isSameStatusColor(color, colorStyle);
        return (
          <StyledColorBlock
            key={`${backgroundColor}-${index}`}
            {...{ selected }}
            colorValue={backgroundColor}
            onClick={() => onChange?.(selected ? undefined : colorStyle)}
          >
            <div className='content' style={colorStyle}>
              {selected ? <CheckIcon color='inherit' className='icon' /> : ''}
            </div>
          </StyledColorBlock>
        );
      })}
    </Grid>
  );
};

export default ColorSelector;
